// data path
const datapath = "http://lpm.mx/data/v21/";

export default datapath;